import React from 'react';

import { link } from '@aline/routes';
import { useNavigate } from 'react-router-dom';
import { PartyDialog } from 'src/components';
import { useCreateParty } from 'src/hooks';

interface NewPartyDialogProps {
  handleClose: () => void;
  open: boolean;
}

export function NewPartyDialog(props: NewPartyDialogProps): JSX.Element {
  const navigate = useNavigate();
  const { createParty } = useCreateParty();

  return (
    <PartyDialog
      handleSubmit={async ({ description, name }) => {
        const { data } = await createParty({
          variables: { input: { props: { description, name } } },
        });
        if (data) navigate(link.PartyDetailDocuments({ partyId: data.createParty.id }));
      }}
      {...props}
    />
  );
}
